import { ApiService } from './api.service';
import { TokenService } from './storage.service';

class AuthenticationError extends Error {
    constructor(errorCode, message) {
        super(message);
        this.message = message === 'Invalid username or password' ? 'Неверный логин или пароль' : message;
        this.name = this.constructor.name;
        this.errorCode = errorCode;
    }
}

const UserService = {
    /**
     * Login the user and store the access token to TokenService.
     *
     * @returns access_token
     * @throws AuthenticationError
     **/
    login: async function(login, password) {
        let formData = new FormData();
        formData.append('grant_type', 'password');
        formData.append('username', login);
        formData.append('password', password);
        let requestData = {
            method: 'post',
            url: '/v1/customAuth/login',
            data: formData
        };

        try {
            let response = await ApiService.customRequest(requestData);

            TokenService.saveToken(response.data.access_token);
            //TokenService.saveRefreshToken(response.data.refresh_token);
            ApiService.setHeader();

            // TODO: разобраться с RefreshToken
            //ApiService.mount401Interceptor();

            return response.data.access_token;
        } catch (error) {
            throw new AuthenticationError(error.response.status, error.response.data.message);
        }
    },

    /**
     * Авторизует пользователя по существующему токену авторизации
     *
     * @param {*} authToken - существующий токен авторизации
     * @throws AuthenticationError
     **/
    loginWithToken: async function(authToken) {
        try {
            TokenService.saveToken(authToken);
            //TokenService.saveRefreshToken(???);
            ApiService.setHeader();

            // TODO: разобраться с RefreshToken
            //ApiService.mount401Interceptor();
        } catch (error) {
            throw new AuthenticationError(error.response.status, error.response.data.detail);
        }
    },

    /**
     * Refresh the access token.
     **/
    refreshToken: async function() {
        let refreshToken = TokenService.getRefreshToken();
        let formData = new FormData();
        formData.append('grant_type', 'refresh_token');
        formData.append('refresh_token', refreshToken);

        let requestData = {
            method: 'post',
            url: '/v1/login',
            data: formData
        };

        try {
            let response = await ApiService.customRequest(requestData);

            TokenService.saveToken(response.data.access_token);
            TokenService.saveRefreshToken(response.data.refresh_token);
            // Update the header in ApiService
            ApiService.setHeader();

            return response.data.access_token;
        } catch (error) {
            throw new AuthenticationError(error.response.status, error.response.data.detail);
        }
    },

    /**
     * Logout the current user by removing the token from storage.
     *
     * Will also remove `Authorization Bearer <token>` header from future requests.
     **/
    logout() {
        // Remove the token and remove Authorization header from Api Service as well
        TokenService.removeToken();
        TokenService.removeRefreshToken();
        ApiService.removeHeader();

        // TODO: разобраться с RefreshToken
        //ApiService.unmount401Interceptor();
    },

    /**
     * Возвращает информацию по текущему пользователю
     *
     **/
    getUsersCurrent: async function() {
        try {
            let response = await ApiService.get('v1/users/current');

            return response.data;
        } catch (error) {
            throw error;
        }
    },
    /**
     * Возвращает информацию по номеру лицевого счёта
     *
     **/
    getAccountInfo: async function(accountNumber) {
        try {
            let response = await ApiService.get(`v1/users/getAccountInfo/${accountNumber}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    /**
     * Возвращает информацию о показаниях по номеру лицевого счёта
     *
     **/
    getAccountCntInfo: async function(accountNumber) {
        try {
            let response = await ApiService.get(`v1/users/getAccountCntInfo/${accountNumber}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    /**
     * Возвращает информацию о тарифах по номеру лицевого счёта
     *
     **/
    getAccountTariffInfo: async function(accountNumber) {
        try {
            let response = await ApiService.get(`v1/users/getAccountTariffInfo/${accountNumber}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    /**
     * Возвращает информацию о распломбировании по номеру лицевого счёта
     *
     **/
    getAccountUnsealInfo: async function(accountNumber) {
        try {
            let response = await ApiService.get(`v1/users/getAccountUnsealInfo/${accountNumber}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
};

export default UserService;

export { UserService, AuthenticationError };
